import React, { FC, useEffect, useLayoutEffect } from 'react';
import { Outlet } from 'react-router';
import { NavSidebarDrawer } from 'src/components/Drawer/NavSidebarDrawer';
import { AccountProvider } from 'src/providers/account/provider';
import { TrialGuard } from 'src/components/TrialGuard';
import { SidebarProvider } from 'src/providers/sidebar/provider';

import { ConnectorsProvider } from '../providers/connectors/provider';
import { mountIubendaPrivateGuard } from 'src/utils/iubendaPublicConsentWidget';

import { Box } from '@mui/material';
import { ShopifySyncTopBar } from 'src/components/ShopifySyncTopBar';
import { MagentoSyncTopBar } from 'src/components/MagentoSyncTopBar';

export const PrivateTemplate: FC = () => {
  // Il widget Iubenda è consentito solo nel pubblico: nell'area privata lo nascondiamo
  // subito e rimuoviamo eventuali nodi iniettati in ritardo dopo il cambio route SPA.
  useLayoutEffect(() => {
    return mountIubendaPrivateGuard();
  }, []);

  // Blocca indicizzazione Google per tutte le pagine private
  useEffect(() => {
    // Aggiungi meta robots noindex
    let metaRobots = document.querySelector('meta[name="robots"]');
    if (!metaRobots) {
      metaRobots = document.createElement('meta');
      metaRobots.setAttribute('name', 'robots');
      document.head.appendChild(metaRobots);
    }
    metaRobots.setAttribute(
      'content',
      'noindex, nofollow, noarchive, nosnippet',
    );

    // Aggiungi meta googlebot
    let metaGooglebot = document.querySelector('meta[name="googlebot"]');
    if (!metaGooglebot) {
      metaGooglebot = document.createElement('meta');
      metaGooglebot.setAttribute('name', 'googlebot');
      document.head.appendChild(metaGooglebot);
    }
    metaGooglebot.setAttribute(
      'content',
      'noindex, nofollow, noarchive, nosnippet',
    );

    // Cleanup quando il componente viene smontato
    return () => {
      // Non rimuoviamo i meta tag perché potrebbero servire anche dopo
      // ma li resettiamo al default pubblico se necessario
    };
  }, []);

  return (
    <AccountProvider>
      <ConnectorsProvider>
        <TrialGuard>
          <ShopifySyncTopBar />
          <MagentoSyncTopBar />
          <SidebarProvider>
            <Box
              sx={{
                display: 'flex',
                minHeight: '100vh',
                width: '100%',
                maxWidth: '100vw',
                overflowX: 'hidden',
                paddingTop: 'var(--kipify-topbar-height, 0px)',
              }}
            >
              <NavSidebarDrawer />
              <Box
                component="main"
                sx={{
                  flexGrow: 1,
                  // Flex item must shrink below intrinsic content width (wide markdown tables).
                  minWidth: 0,
                  width: '100%',
                  maxWidth: '100%',
                  p: { xs: 0, sm: 3 }, // Rimuove padding su mobile per allineare al layout 712abe1
                  overflowX: 'hidden',
                  overflowY: 'auto',
                }}
              >
                <Outlet />
              </Box>
            </Box>
          </SidebarProvider>
        </TrialGuard>
      </ConnectorsProvider>
    </AccountProvider>
  );
};
